document.addEventListener('DOMContentLoaded', function() {
    // Find the elements
    const sizeChartDrawer = document.getElementById('Complementary-1-drawer');
    const productPriceElement = document.querySelector('[id^="Product-Price-template--"]');
    
    // Check if both elements exist
    if (sizeChartDrawer && productPriceElement) {
        // Insert the size chart drawer after the product price element
        productPriceElement.parentNode.insertBefore(sizeChartDrawer, productPriceElement.nextSibling);
        
        // Alternatively, you could use:
        // productPriceElement.after(sizeChartDrawer);
    }
});